//  Third party imports
import { deserialize, deserializeAs } from 'cerialize';
import { RNode } from './organization-record';

export class RDisplayInfo {
    @deserialize
    public name: string;
    @deserialize
    public value: string;
}

export class RPermissionScope {
    @deserialize
    public nodeType: string;
    @deserialize
    public nodeId: number;
    @deserialize
    public nodeName: string;
    @deserialize
    public nodePath: string;
    @deserialize
    public entityType: string;
    @deserialize
    public entityId: number;
}

export class RAccountDetails {
    @deserialize
    public accountCompany: string;
    @deserialize
    public accountEmail: string;
    @deserialize
    public displayEmail: string;
    @deserialize
    public accountId: number;
    @deserialize
    public nodeId: number;
    @deserialize
    public allAssetsAccess: boolean;
    @deserialize
    public iamAccountName: string;
    @deserialize
    public iamUserName: string;
    @deserialize
    public isMasterUser: boolean;
    @deserialize
    public masterUserName: string;
    @deserialize
    public userAuthenticationPassed: boolean;
    @deserialize
    public userAuthenticationUrl: string;
    @deserialize
    public userEmail: string;
    @deserialize
    public userGroup: string;
    @deserialize
    public userId: number;
    @deserializeAs(RDisplayInfo)
    public userDisplayInfo: Array<RDisplayInfo>;
    @deserializeAs(RPermissionScope)
    public permissionScope: RPermissionScope;

    // for UI
    public selectedNode: RNode;
}


